//@flow

import React, { useState } from 'react';
import styled from 'styled-components';
import { media } from 'styles/Mixins';

const ContentBlock = styled.div`
  background-color: white;
`;

export const IndexContent = styled(ContentBlock)`
  margin-bottom: 5px;
  border-bottom: 1px solid #e9e9e9;
`;

export const IndexSectionHeader = styled.div`
  padding: 5px;
  display: flex;
  align-items: center;
  height: 50px;
`;

export const SectionName = styled.h3`
  font-size: 14px;
  font-weight: bold;
  margin: 0;
  flex: 1 1 248px;
`;

export const SectionTogglerContainer = styled.span`
  cursor: pointer;
  line-height: 42px;
`;

const SectionToggler = styled.img.attrs({
  src: '/assets/up-arrow-black.svg'
})`
  transform: rotate(${props => (props.isOpen ? 0 : 180)}deg);
  transition: transform 0.5s ease-in-out;
`;

export const IndexSectionElements = styled.div`
  max-height: ${props => (props.isOpen ? '1000px' : 0)};
  padding: ${props => (props.isOpen ? 20 : 0)}px 0px;
  transition: all 0.5s ease-out;
  overflow: hidden;
`;

const OrderedList = styled.ol`
  counter-reset: item;
  padding: 0;
  margin: 0;
`;

const ListItem = styled.li`
  display: ${props => (props.isFlex ? 'flex' : 'block')};
  cursor: pointer;
  &:before {
    color: ${({ theme }) => theme.color.primary};
    content: counters(item, '.') '. ';
    counter-increment: item;
    flex: 0 0 25px;
    width: 25px;
    display: inline-block;
  }
`;

export const Content = styled.div`
  background: #ffffff;
`;

const PositionNumber = styled.h3`
  margin: 0;
  color: ${({ theme }) => theme.color.primary};
  line-height: 29px;
  letter-spacing: 0;
  font-size: 24px;
  font-weight: 700;
  padding-left: 20px;
  ${media.sm`
    font-weight: 400;
  `}
`;

type PropsType = {
  questions: Array<any>
};

const Accordion = (props: PropsType) => {
  const [selectedItem, setSelectedItem] = useState(null);

  const renderIndex = (elements: []) => (
    <OrderedList>
      {elements.map((element, elIndex) => {
        return (
          <ListItem key={elIndex} isFlex={element.elements === undefined}>
            {element.title}
            {element.elements && renderIndex(element.elements)}
          </ListItem>
        );
      })}
    </OrderedList>
  );

  const renderSectionContent = (
    section: {},
    index: number,
    isVisible: boolean
  ) => (
    <IndexSectionElements isOpen={isVisible} key={index}>
      {section.response()}
    </IndexSectionElements>
  );

  return (
    <Content>
      {props.questions.map((item, index) => {
        const isSelected = selectedItem === index;
        const defaultOpen = item.isOpen || false;
        return (
          <IndexContent key={index}>
            <IndexSectionHeader>
              {item.position && (
                <PositionNumber>{item.position}</PositionNumber>
              )}
              <SectionName>{item.question}</SectionName>
              {!defaultOpen && (
                <SectionTogglerContainer>
                  <SectionToggler
                    isOpen={isSelected}
                    onClick={() => {
                      setSelectedItem(isSelected ? null : index);
                    }}
                  />
                </SectionTogglerContainer>
              )}
            </IndexSectionHeader>
            {item &&
              renderSectionContent(
                item,
                index,
                defaultOpen ? defaultOpen : isSelected
              )}
          </IndexContent>
        );
      })}
    </Content>
  );
};

export default Accordion;
